import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import async from 'async';
import { Link } from 'react-router-dom';
import { AppTheme } from '../styles/AppTheme';
import { CommonStyles, CommonTheme } from '../styles/Styles';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import { EmptyMsgView } from '../components/EmptyMsgView';
import { AppHelper } from '../helpers/AppHelper';
import { BreadCrumbs } from '../common/components/BreadCrumbs';

function RowItems({ children, title, index }) {
  return (
    <div className={css(Styles.subContainer)}>
      <div className={css(Styles.leftContainer)}>
        <p className={css(Styles.productDetailsTitle)}>
          {title}
        </p>
      </div>
      <div className={((index % 2 === 0) && window.innerWidth > 767) ?
        css(Styles.rightContaner)
        :
        css([Styles.rightContaner, Styles.rightContanerSpec])}>
        <div className={css(Styles.rightSubContainer)}>
          {children}
        </div>
      </div>
    </div>
  );
}

export class CompareProducts extends Component {
  constructor(props) {
    super(props)
    this.item = (this.props.location.state && this.props.location.state.item) ? this.props.location.state.item : null
    this.state = {
      fetchState: ApiHelper.State.LOADING,
    }
    this.catSlug = this.props.match.params ? this.props.match.params.slug : null
    this.catParamsIdToNameMap = null

    this.breadCrumbs = [
      { title: 'Home', to: '/' },
      { title: 'Compare' },
    ]
  }

  componentDidMount() {
    this.fetchItems()
  }

  fetchItems = () => {
    if (!this.catSlug) {
      return
    }

    const options = {
      method: 'GET',
      authWithKey: true,
      endPoint: ApiHelper.makeUrlPath(['miscs', 'products'], { catSlug: this.catSlug })
    };

    ApiHelper.call(options, (err, result) => {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }

      if (!result || !result.items || result.items.length === 1) {
        this.setState({
          errMsg: Helper.getString('productComparisonFailed'),
          fetchState: ApiHelper.State.ERROR
        })
        return
      }

      const prods = []

      if (this.item) {
        for (const r of result.items) {
          if (prods.length > 1) {
            break
          }
          if (this.item.id !== r.id) {
            prods.push(r)
          }
        }
      } else {
        for (const r of result.items) {
          if (prods.length > 2) {
            break
          }
          prods.push(r)
        }
      }

      this.fetchProdDetails(prods)
    });
  }

  fetchProdDetails = (prods) => {
    const fcns = []
    for (const p of prods) {
      fcns.push(function (callback) {
        const options = {
          method: 'GET',
          authWithKey: true,
          endPoint: ApiHelper.makeUrlPath(['miscs', 'products'], { slug: p.slug })
        };
        ApiHelper.call(options, (err, result) => {
          if (err) return callback(err)
          callback(null, result)
        });
      })
    }

    const thisObj = this
    async.parallel(fcns, function (err, results) {
      if (err) {
        thisObj.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }

      if (thisObj.item) {
        results.push(thisObj.item)
      }
      const compareProds = {}
      for (const r of results) {
        compareProds[r.id] = {}
        compareProds[r.id].data = r
        compareProds[r.id].images = AppHelper.getProductImages(r)
        compareProds[r.id].paramsToNameMap = AppHelper.getParamsIdToNameMap(r)

        if (!r.params) {
          continue
        }

        if (!thisObj.catParamsIdToNameMap) {
          thisObj.catParamsIdToNameMap = AppHelper.getParamsIdToNameMap(r)
        }

        Object.keys(r.params).map((key, index) => {
          if (!compareProds[r.id]) {
            return
          }

          if (!compareProds[r.id].params) {
            compareProds[r.id].params = {}
          }

          if (compareProds[r.id].paramsToNameMap[key]) {
            compareProds[r.id].params[key] = {
              title: compareProds[r.id].paramsToNameMap[key],
              value: r.params ? r.params[key] : ''
            }
          }
        })
      }

      const prodAttributes = {}
      Object.keys(thisObj.catParamsIdToNameMap).map((pKey, index) => {
        Object.keys(compareProds).map((key, index) => {
          if (!compareProds[key].params) return
          if (!prodAttributes[pKey]) {
            prodAttributes[pKey] = {}
          }
          prodAttributes[pKey][key] = compareProds[key].params ? compareProds[key].params[pKey] : ''
          if (!prodAttributes[pKey].title) {
            prodAttributes[pKey].title = thisObj.catParamsIdToNameMap[pKey]
          }
        })
      })

      for (const paramKey in prodAttributes) {
        for (const prodKey in compareProds) {
          if (prodAttributes[paramKey][prodKey]) {
            continue
          }
          prodAttributes[paramKey][prodKey] = {
            title: '',
            value: Helper.getString('emptyData')
          }
        }
      }

      thisObj.setState({
        prodAttributes: prodAttributes,
        compareProds: compareProds,
        productKeys: Object.keys(compareProds).sort(),
        fetchState: ApiHelper.State.READY,
      })
    })
  }

  getImageForFirstrow(item) {
    if (!item) return ''

    let imageUrl = ''
    if (item.images && item.images.length !== 0) {
      imageUrl = item.images[0].image
    }

    const toUrl = '/products/' + (item.data ? item.data.slug : '')

    return (
      <Link
        key={toUrl}
        className={css(Styles.rowItems)}
        to={toUrl}>
        <div className={css(Styles.rowItemsSubContainer)}>
          <img src={imageUrl} className={css(Styles.productImage)} />
          <p className={css([CommonStyles.listItemTitle, Styles.listItemTitle])}>{item.data ? item.data.title : ''}</p>
        </div>
      </ Link>
    )
  }

  getProductDescr(item, index) {
    let value = Helper.getString('emptyData')
    if (item && item.value) {
      value = item.value
    }
    return (
      <div key={index} className={css(Styles.rowItems)}>
        <div className={css(Styles.rowItemsSubContainer)}>
          <p className={css(Styles.productDescrTitle)}>{value}</p>
        </div>
      </div>
    )
  }

  isPresentInAll = (key) => {
    const keyArr = this.state.productKeys
    let present = false
    for (const productKey of keyArr) {
      const item = this.state.prodAttributes[key][productKey]
      if (item && item.value !== Helper.getString('emptyData')) {
        present = true
        return present
      }
    }
    return present
  }

  renderProdUrl = (item) => {
    const toUrl = '/products/' + (item.data ? item.data.slug : '')
    return (
      <Link
        to={toUrl}
        className={css(Styles.link)}>
        <p
          className={css(CommonStyles.viewAllDeals, Styles.viewAllDealsCust)}>
          View product
          <i className={'material-icons ' + css(CommonStyles.viewAllIcon, Styles.viewAllIconCust)}>
            keyboard_arrow_right
          </i>
        </p>
      </Link>
    )
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return <EmptyMsgView msg={this.state.errMsg} />
    } else {
      return this.readyView();
    }
  }

  readyView() {
    return (
      <div className={css(Styles.container)}>
        <div className={css(Styles.compareProductsContainer)}>
          <div className={css(Styles.leftContainerC)} />
          <div className={css(Styles.rightContaner)}>

            <div className={css(Styles.titleContainer)}>
              <h1 className={css([CommonStyles.pageTitle, Styles.pageTitle])}>
                Compare similar products
              </h1>
            </div>

            <div className={css(Styles.bcContainer)}>
              <BreadCrumbs breadCrumbs={this.breadCrumbs} />
            </div>

            <div className={css(Styles.compareProductsDetailsContainer)}>
              <div className={css(Styles.firstRow)}>
                {this.state.productKeys.map((productKey, index) => {
                  return this.getImageForFirstrow(this.state.compareProds[productKey])
                })}

              </div>
            </div>

          </div>
        </div>

        {Object.keys(this.state.prodAttributes).map((key, index) => {
          if (!this.state.prodAttributes[key] || !this.state.prodAttributes[key].title) {
            return
          }
          if (!this.isPresentInAll(key)) {
            return
          }
          return (
            <RowItems key={index} index={index} title={this.state.prodAttributes[key].title}>
              {this.state.productKeys.map((productKey, index) => {
                return (
                  this.getProductDescr(this.state.prodAttributes[key][productKey], index)
                )
              })}
            </RowItems>
          )
        })}

        <div className={css(Styles.compareProductsContainer)}>
          <div className={css(Styles.leftContainerC)} />
          <div className={css(Styles.rightContaner)}>
            <div className={css(Styles.firstRow)}>
              {this.state.productKeys.map((productKey, index) => {
                return this.renderProdUrl(this.state.compareProds[productKey])
              })}
            </div>
          </div>
        </div>

      </div>
    )
  }
}

const Styles = StyleSheet.create({
  container: {
    flex: 0.7,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 40,
    '@media(min-width: 768px) and (max-width: 768px)': {
      flex: 0.9,
    },
    '@media(max-width: 767px)': {
      flex: 1,
    },
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: '10px 0px',
    '@media(max-width: 767px)': {
      margin: 0,
      flexDirection: 'column',
    },
  },
  compareProductsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '30px'
  },
  leftContainer: {
    flex: 0.25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '@media(max-width: 767px)': {
      justifyContent: 'center',
    },
  },
  leftContainerC: {
    flex: 0.25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '@media(max-width: 767px)': {
      justifyContent: 'center',
      display: 'none'
    },
  },
  rightContaner: {
    flex: 0.75,
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 15px 0px 15px',
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      padding: '0px 10px 0px 10px',
      flex: 1
    },
  },
  rightContanerSpec: {
    backgroundColor: '#F4F4F4'
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,//AppTheme.pagePadding * 4,
    flex: 1
  },
  shareButton: {
    backgroundColor: CommonTheme.white,
    color: CommonTheme.textColor,
  },
  shareIcon: {
    width: 20,
    height: 15,
    marginLeft: AppTheme.pagePadding / 2
  },
  compareProductsDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  firstRow: {
    display: 'flex',
    flex: 1
  },
  rowItems: {
    textDecoration: 'none',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    '@media(max-width: 767px)': {
      marginLeft: 0,
      marginRight: 10
    },
  },
  productImage: {
    width: 110,
    height: 110,
    border: '0.5px solid lightgrey',
    padding: 1,
    borderRadius: CommonTheme.borderRadius,
    overflow: 'hidden',
    '@media(max-width: 767px)': {
      width: 80,
      height: 80,
    },
  },
  listItemTitle: {
    marginTop: AppTheme.pagePadding * 2,
  },
  rowItemsSubContainer: {
    width: '65%',
    '@media(max-width: 767px)': {
      width: '100%',
    },
  },
  rightSubContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  productDetailsTitle: {
    marginRight: 20,
    fontWeight: 'bolder',
    '@media(max-width: 767px)': {
      marginRight: 5,
    },
  },
  productDescrTitle: {
    fontSize: '12px'
  },
  pageTitle: {
    flex: 1,
    margin: 0
  },
  link: {
    textDecoration: 'none',
    flex: 1
  },
  viewAllDealsCust: {
    color: CommonTheme.textColor,
    fontSize: 15,
    justifyContent: 'flex-start',
    '@media(max-width: 767px)': {
      fontSize: 12,
    },
  },
  viewAllIconCust: {
    color: CommonTheme.textColor,
    fontSize: 30,
    marginLeft: AppTheme.pagePadding,
    '@media(max-width: 767px)': {
      fontSize: 18,
    },
  },
  bcContainer: {
    marginBottom: 20,
  }
})


// WEBPACK FOOTER //
// ./src/screens/CompareProducts.js